import { useAuth } from "../store/AuthContext";
import { ROLE } from "../constants/auth";
import { can as checkPermission } from "../config/permissions";

/**
 * Single source of truth for role-based UI gating.
 * Backed by the permission config at `src/config/permissions.js`.
 */
export const useCan = () => {
  const { role } = useAuth();
  const has = (cap) => checkPermission(cap, role);

  return {
    role,
    isAdmin:   role === ROLE.ADMIN,
    isOwner:   role === ROLE.OWNER,
    isCashier: role === ROLE.BAR_CASHIER,

    // Master / system data
    modify:           has("manageMasterData"),
    create:           has("manageMasterData"),
    edit:             has("manageMasterData"),
    delete:           has("manageMasterData"),
    toggleStatus:     has("manageMasterData"),
    seeAdministration:has("manageUsers"), // sidebar visibility
    manageUsers:      has("manageUsers"),
    manageNotifications: has("manageNotifications"),
    viewAuditLogs:    has("viewAuditLogs"),

    // Read / monitor
    viewAdmin:        has("viewAdmin"),
    approveCorrection:has("approveCorrection"),
    exportReports:    has("exportReports"),
    monitorCashiers:  has("monitorCashiers"),

    // POS
    operatePOS:       has("operatePOS"),
  };
};
